import { IShippingAddress } from '@/interfaces/shipping-address';

const getShippingFullAddress = (shipping?: IShippingAddress) => {
  if (!shipping) return '';
  return `${shipping.address || ''} ${shipping.road || ''} ${shipping.subdistrictNameTh || ''} ${shipping.districtNameTh || ''} ${shipping.provinceNameTh || ''} ${shipping.country || ''} ${shipping.postalCode || ''}`;
};

export { getShippingFullAddress };
